var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex",staticStyle:{"height":"calc(100vh)"}},[_c('Sidebar'),_c('div',{staticClass:"container-wrapper"},[_c('div',{staticClass:"container-fluid py-3"},[_c('router-view',{key:_vm.$store.state.auth.forceReload})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }